export const USER_HAS_ACTIVE_CRITERIA_MEMBERSHIP = 'USER_HAS_ACTIVE_CRITERIA_MEMBERSHIP';
